import { calcDateSpanDescription, User } from 'model';
import { NavLink } from 'react-router-dom';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../../styles/Shared.module.css';
import { ProfilePic } from '../ProfilePic';
import styles from './UserItem.module.css';

const UserItemContents: React.FC<{
	user: User | undefined;
}> = ({ user }) => {
	return (
		<div className={styles.userItemContainer}>
			{user && (
				<div className={sharedStyles.authorHeader}>
					<ProfilePic user={user} />
					<div>
						<div className={sharedStyles.name}>{user.username}</div>
						<span className={sharedStyles.time}>
							Joined {calcDateSpanDescription(new Date(user.created).toISOString())}
						</span>
					</div>
				</div>
			)}
		</div>
	);
};

export const UserItem: React.FC<{ user: User; modal?: boolean }> = ({ user, modal }) => {
	return (
		<>
			{user && (
				<>
					{modal ? (
						<UserItemContents user={user} />
					) : (
						<NavLink to={`/main/settings/admin/useradmin/${user._id}/`} className="nounderline">
							<UserItemContents user={user} />
						</NavLink>
					)}
				</>
			)}
		</>
	);
};
